/* Pets Paradise Horizon 2030 interactions */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  onReady(function () {
    function onScroll() {
      var y = window.scrollY || 0;
      document.documentElement.classList.toggle('pp-header-scrolled', y > 12);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var els = document.querySelectorAll('.pp-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.style.animationPlayState = 'running';
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) {
        el.style.animationPlayState = 'paused';
        io.observe(el);
      });
    }
  });
})();

/* === SALES CONVERSION BOOST JS === */
(function(){
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn); else fn(); }
  ready(function(){
    var path=location.pathname||'';
    var onBuy=/\/products\//.test(path)||/\/collections\//.test(path)||path==='/cart'||path==='/';
    if(onBuy && !document.querySelector('.pp-sales-bar')){
      var bar=document.createElement('div');
      bar.className='pp-sales-bar';
      bar.innerHTML='<span><strong>PETS10</strong> = 10% off first order</span><span><strong>Buy 2</strong> save 10% auto</span><span>FREE ship $59+ AU · 30-day guarantee</span><a href="/collections/all?sort_by=best-selling">Shop best sellers →</a>';
      document.body.appendChild(bar);
    }
    document.querySelectorAll('.card__content, .card-information').forEach(function(card,i){
      if(i>30||card.querySelector('.pp-quick-sale')) return;
      var el=document.createElement('div'); el.className='pp-quick-sale'; el.textContent='Buy 2 save 10% · code PETS10'; card.appendChild(el);
    });
  });
})();
